:host {
  /**
   * @prop --c-accordion-item-header-background-color: Accordion item header background color
   * @prop --c-accordion-item-outline-color: Accordion item outline color
   * @prop --c-accordion-item-text-color: Accordion item text color
   */
  --_c-accordion-item-header-background-color: var(--c-accordion-item-header-background-color, var(--c-primary-200));
  --_c-accordion-item-outline-color: var(--c-accordion-item-outline-color, var(--c-primary-600));
  --_c-accordion-item-text-color: var(--c-accordion-item-text-color, var(--c-primary-600));

  max-width: 100%;

  summary::-webkit-details-marker {
    display: none;
  }
}

.c-accordion-item {
  $this: &;

  --_c-accordion-item-indicator-rotation: rotate(-90deg);
  --_c-accordion-item-content-height: 0;
  --_c-accordion-item-min-height: 46px;
  --_c-accordion-item-border-radius: 6px;
  --_c-accordion-item-padding: 12px;
  --_c-accordion-item-overflow: visible;
  --_c-accordion-item-outline-color-offset: 2px;

  display: block;
  overflow: var(--_c-accordion-item-overflow);

  &--expanding {
    --_c-accordion-item-overflow: hidden !important;
    --_c-accordion-item-outline-color: transparent;
  }

  &--expanded {
    --_c-accordion-item-content-height: auto;
    --_c-accordion-item-indicator-rotation: rotate(90deg);
    --_c-accordion-item-overflow: visible;
  }

  &--outlined {
    box-shadow: inset 0 0 0 2px var(--_c-accordion-item-header-background-color);
    border-radius: var(--_c-accordion-item-border-radius);
  }

  &__header {
    min-height: var(--_c-accordion-item-min-height);
    user-select: none;
    background-color: var(--_c-accordion-item-header-background-color);
    display: grid;
    column-gap: 8px;
    align-items: center;
    padding: 0 var(--_c-accordion-item-padding);
    border-radius: var(--_c-accordion-item-border-radius);
    cursor: pointer;
    grid-template-columns: 1fr auto;
    border: none;
    text-align: left;
    margin: 0;
    font-family: var(--c-font-family);
    position: relative;

    &--has-icon {
      grid-template-columns: auto 1fr auto;
    }

    &--expanded {
      cursor: default;

      &#{$this}__header--collapsable {
        cursor: pointer;
      }
    }

    &:focus {
      outline: 2px var(--_c-accordion-item-outline-color) solid;
      outline-offset: var(--_c-accordion-item-outline-color-offset);
    }

    @supports selector(:focus-visible) {
      &:focus {
        outline: none;
      }
    }

    &:focus-visible {
      outline: 2px var(--_c-accordion-item-outline-color) solid;
      outline-offset: var(--_c-accordion-item-outline-color-offset);
    }
  }

  &__title {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    color: var(--_c-accordion-item-text-color);
  }

  &__content {
    padding: 16px;
  }

  &__content-wrapper {
    overflow: visible;
  }

  &__icon {
    height: 24px;
    font-size: 24px;
    color: var(--_c-accordion-item-text-color);
    display: flex;
    align-items: center;

    > * {
      height: 24px;
      display: flex;
      align-items: center;
    }
  }

  &__indicator {
    display: flex;
    align-items: center;
    color: var(--_c-accordion-item-text-color);
    justify-self: end;

    c-icon {
      width: 24px;
      height: 24px !important;
      transform: var(--_c-accordion-item-indicator-rotation);
      transition: transform 0.3s ease;
    }
  }
}
